import { makeHttpRequest } from "@/shared";

export const saveSelling = async (sessionKey) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/builder/${sessionKey}/save`,
            method: "POST",
        })
    ).data;

    return response;
};
